import React from 'react';

import { YesBtn, NoBtn } from './Button';

import { Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    Title : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    Content : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    ScrollableContent : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        overflowY: 'auto',
        maxHeight: '30vh',
    },
    root : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '16px !important',
        fontWeight : '400 !important',
    },
    rootMob : { 
        justifyContent : 'flex-start',
        padding : '0',
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        fontSize : '10px !important',
        fontWeight : '400 !important',
    },
    PaperMob : {
        width : '80%',
        backgroundColor : 'black',
        color : 'white',
    },
    Paper : {
        width : '50%',
        backgroundColor : 'black',
        color : 'white',
    }

}));

const ReceiverPrompt = function ReceiverPrompt({ view, open , name , result }){

    const classes = useStyles();

    

    return(
        <Dialog classes={{ paper : view === 'mobile' ? classes.PaperMob : classes.Paper }} maxWidth='xl' open={open} >
            <DialogTitle disableTypography={true} classes={{ root : classes.Title }} >
                Do you want to allow {name}?
            </DialogTitle>
            <DialogActions>
                <YesBtn handleClick={()=>{ result(true) }} />
                <NoBtn handleClick={()=>{ result(false) }} />
            </DialogActions>
        </Dialog>
    )

}

export default ReceiverPrompt;